import "date-fns";
import parse from "date-fns/parse";
import parseJSON from "date-fns/parseJSON";
import format from "date-fns/format";

export default {
  miscHelper: {

    getCurrencyFormatter: function () {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      return formatter;
    },
        
    getWholeDollarAmount: function (value, includeCents = false) {
      if(value === 0) return 'FREE';
      const v = this.getCurrencyFormatter().format(value);      
      return includeCents === true ? v : v.substr(0, v.length - 3);      
    },

    getReviewColumnText: function (row, col, includeCents) {  
      const item = row[col];
      let ret = "";
      if (item) {
        if (item.data) {
          // means...this is amount column.
          const amount = item.data;
          if (amount.v0 >= 0 && amount.v1 >= 0) {
            // v0 is full amount, v1 is actual/discounted amount being charged.
            if (amount.v1 >= amount.v0)
              ret = `${this.getWholeDollarAmount(amount.v1, includeCents)}`;
            else {
              ret = `<del>${this.getWholeDollarAmount(
                amount.v0, includeCents
              )}</del> ${this.getWholeDollarAmount(amount.v1, includeCents)}`;
            }
          } else ret = `${this.getWholeDollarAmount(amount.v0, includeCents)}`;
        } else ret = item.text;
      }
      return { __html: ret };
    },

    isRoutingNumberValid: function (number) {      
      if (!number) { // all 0's is technically a valid routing number, but it's inactive
        return false;
      }    
      const routing = number.toString();
      // while (routing.length < 9) {
      // routing = `0${routing}`;
      // }
      // gotta be 9  digits
      const match = routing.match('^\\d{9}$');
      if (!match) {
        return false;
      }
      // The first two digits of the nine digit RTN must be in
      // the ranges 00 through 12, 21 through 32, 61 through 72, or 80.
      // https://en.wikipedia.org/wiki/Routing_transit_number
      // eslint-disable-next-line radix
      const firstTwo = parseInt(routing.substring(0, 2));
      const firstTwoValid = (firstTwo >= 0 && firstTwo <= 12)
                          || (firstTwo >= 21 && firstTwo <= 32)
                          || (firstTwo >= 61 && firstTwo <= 72)
                          || firstTwo === 80;
      if (!firstTwoValid) {
        return false;
      }
      // this is the checksum
      // http://www.siccolo.com/Articles/SQLScripts/
      // how-to-create-sql-to-calculate-routing-check-digit.html
      const weights = [3, 7, 1];
      let sum = 0;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < 8; i++) {
        // eslint-disable-next-line radix
        sum += parseInt(routing[i]) * weights[i % 3];
      }
      // eslint-disable-next-line radix
      return (10 - (sum % 10)) % 10 === parseInt(routing[8]);
    },
    getCenterNameById: function (id) {
      let ret = id.toUpperCase();
      let parts = ret.split("-");
      // console.log('\tParts', parts);
      const last = parts[parts.length - 1];
      if (last.length === 2) parts = parts.slice(0, parts.length - 1);
      // _.remove(parts, (p) => p.length === 2);
      // console.log('\tParts after removing', parts);
      let splitIndex = parts.indexOf("NORTH");
      if (splitIndex === -1) splitIndex = parts.indexOf("SOUTH");
      if (splitIndex === -1) splitIndex = parts.indexOf("EAST");
      if (splitIndex === -1) splitIndex = parts.indexOf("WEST");
      if (splitIndex === -1) splitIndex = parts.indexOf("TOWN");
      if (splitIndex >= 0) {
        const firstSep = splitIndex === 0 ? 1 : splitIndex;
        const parts1 = parts.slice(0, firstSep);
        const parts2 = parts.slice(firstSep);
        // console.log('\tPart1, ', parts1);
        // console.log('\tPart2, ', parts2);
        const separator = splitIndex === 0 ? " " : " - ";
        ret = `${parts1.join(" ")}${separator}${parts2.join(" ")}`;
      } else {
        ret = parts.join(" - ");
      }

      return ret;
    },
  },
  dateHelper: {
    parseDate: function (dt) {
      //console.log('parseDate called with ', dt)
      let d = dt;
      if (dt instanceof Date) {
        //console.log('parseDate, dt is already Date');
      }
      if (typeof dt === "string" || d instanceof String) {
        //console.log('parseDate, dt is String');
        if (dt.length > 10) {
          d = parseJSON(dt);
        } else d = parse(dt, "MM/dd/yyyy", new Date());
      }
      //console.log('Final Parsed Date', d);
      return d;
    },
    format: function (dt) {
      return format(dt, "LL/dd/yyyy");
    },

    format2: function (dt) {
      return format(dt, "EEEE, d MMMM");
    },
    
  },
};
